// component
import React, { useEffect, useRef } from 'react';

import * as Styled from './auto-size-text-area.style';

export type AutoSizeTextAreaProps = Omit<
  React.ComponentProps<'textarea'>,
  'value'
> & {
  value: string;
  inheritTypography?: boolean;
  focusOnMount?: boolean;
};

export const AutoSizeTextArea: React.FC<AutoSizeTextAreaProps> = ({
  value,
  onChange,
  inheritTypography,
  focusOnMount,
  ...rest
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.setAttribute(
        'data-replicated-value',
        value ? value + '\u00A0' : '',
      );
    }
  }, [value]);

  const handleInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (containerRef.current) {
      containerRef.current.setAttribute(
        'data-replicated-value',
        e.target.value + '\u00A0',
      );
    }
    onChange && onChange(e);
  };

  useEffect(() => {
    if (focusOnMount && textAreaRef.current) {
      textAreaRef.current.focus();
      textAreaRef.current.setSelectionRange(value.length, value.length);
    }
    // eslint-disable-next-line -- when the focusOnMount prop changes after rendering, it is not on mount anymore
  }, []);

  return (
    <Styled.Container
      ref={containerRef}
      $inheritTypography={!!inheritTypography}
    >
      <Styled.TextArea
        ref={textAreaRef}
        value={value}
        onChange={handleInput}
        $inheritTypography={!!inheritTypography}
        rows={1}
        {...rest}
      />
    </Styled.Container>
  );
};
